import type React from 'react'

interface LayersIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string
  height?: number | string
  color?: string
}

// Stacked sheets — the drawing-sets / revisions concept.
const LayersIcon: React.FC<LayersIconProps> = ({ width = 20, height = 20, color = '#636F7E', ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m12 2 9 5-9 5-9-5 9-5ZM3 12l9 5 9-5M3 17l9 5 9-5"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LayersIcon
